import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'formik';
import { FocActionCheckRow, FocDetailRow } from '~/components/Patient/Foc/FocGapForm';
import { initFocExistingAnswers } from '~/util';

const propTypes = {
    action: PropTypes.shape().isRequired,
    formik: PropTypes.shape().isRequired,
    handleChange: PropTypes.func.isRequired,
    // eslint-disable-next-line react/require-default-props
    submissionAnswer: PropTypes.shape(),
    readOnly: PropTypes.bool.isRequired,
    isSingle: PropTypes.bool.isRequired,
};

export function FocActionRowComponent({
    action,
    formik,
    handleChange,
    submissionAnswer = null,
    readOnly,
    isSingle,
}) {
    const init = React.useRef(true);
    React.useEffect(() => {
        if (!init.current) return;
        const answers = initFocExistingAnswers(
            submissionAnswer,
            action.foc_action_details,
            action,
            isSingle
        );
        Object.entries(answers).forEach(([key, value]) => {
            handleChange(key, value); // updates parent state so Formik can update initialValues
        });
        init.current = false;
    }, [action, submissionAnswer, isSingle, handleChange]);

    const checkboxId = `foc_action_${action.id}_checked`;
    const needsName =
        (action.foc_action_details.length > 1 ||
            action.foc_action_details[0]?.name !== action.name ||
            action.name === 'need both') &&
        action.name !== 'Screen';
    return (
        <>
            <FocActionCheckRow
                action={action}
                readOnly={readOnly}
                checkboxId={checkboxId}
                formik={formik}
            />
            {formik.values[checkboxId] && (
                <tr>
                    <td colSpan={4}>
                        <table className="foc-action-detail-table">
                            <thead>
                                <tr>
                                    {needsName && <th>Measure</th>}
                                    <th>Date</th>
                                    <th>Results</th>
                                </tr>
                            </thead>
                            <tbody>
                                {action.foc_action_details.map((detail) => (
                                    <FocDetailRow
                                        key={detail.id}
                                        detail={detail}
                                        action={action}
                                        checkboxId={checkboxId}
                                        submissionAnswer={submissionAnswer}
                                        needsName={needsName}
                                        readOnly={readOnly}
                                        formik={formik}
                                    />
                                ))}
                            </tbody>
                        </table>
                    </td>
                </tr>
            )}
        </>
    );
}

FocActionRowComponent.propTypes = propTypes;

export const FocActionRow = connect(FocActionRowComponent);
